import {AgdActionType} from '../ActionType'
import { Dispatch } from 'redux'

/**
 * @typedef Locale Init
 * @returns noting
 * @author IOTA IT
 * @version 0.0.1
 */
export const AgdRequestInit = () => {
    return {
        type:AgdActionType.Agd_INIT
    }
}

export const AgdSuccess = (
    objeckt: any
) => {
    return {
        type: AgdActionType.Agd_INIT,
        objeckt: objeckt
    }
}

export const getAgd = (
    objeckt: any[]
) => {
    return (dispatch: Dispatch) => {
        dispatch(
            AgdSuccess(
                objeckt
            )
        )
    }
}
